// Renders /app/memory/admin_guide.md at /admin/help as a friendly reference.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Minimal markdown → HTML (h1/h2/h3, lists, paragraphs, code)
function mdToHtml(md) {
  const lines = md.split("\n");
  const out = [];
  let inList = false;
  let inCode = false;
  const flushList = () => { if (inList) { out.push("</ol>"); inList = false; } };
  for (const raw of lines) {
    const line = raw;
    if (line.trim().startsWith("```")) {
      if (!inCode) { flushList(); out.push("<pre><code>"); inCode = true; }
      else { out.push("</code></pre>"); inCode = false; }
      continue;
    }
    if (inCode) { out.push(line.replace(/&/g, "&amp;").replace(/</g, "&lt;")); continue; }
    if (line.startsWith("# ")) { flushList(); out.push(`<h1>${line.slice(2)}</h1>`); }
    else if (line.startsWith("## ")) { flushList(); out.push(`<h2>${line.slice(3)}</h2>`); }
    else if (line.startsWith("### ")) { flushList(); out.push(`<h3>${line.slice(4)}</h3>`); }
    else if (/^\d+\.\s/.test(line)) {
      if (!inList) { out.push("<ol>"); inList = true; }
      out.push(`<li>${line.replace(/^\d+\.\s/, "")}</li>`);
    }
    else if (line.startsWith("- ")) {
      if (!inList) { out.push("<ul>"); inList = true; }
      out.push(`<li>${line.slice(2)}</li>`);
    }
    else if (line.trim() === "") { flushList(); out.push(""); }
    else { flushList(); out.push(`<p>${line}</p>`); }
  }
  flushList();
  return out.join("\n")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/`([^`]+)`/g, "<code>$1</code>");
}

export default function HelpPage() {
  const [md, setMd] = useState(null);
  useEffect(() => {
    api.get("/admin/help/guide").then((r) => setMd(r.data.markdown || "")).catch(() => setMd("# Guide unavailable"));
  }, []);
  if (md === null) return <div className="p-8 text-muted-foreground">Loading…</div>;
  return (
    <div className="mx-auto max-w-3xl px-6 py-10 lg:px-10" data-testid="admin-help-page">
      <div
        className="prose prose-lg max-w-none text-foreground [&_h1]:font-display [&_h1]:text-4xl [&_h1]:font-bold [&_h1]:text-primary [&_h1]:mb-6 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-primary [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-bold [&_h3]:text-primary [&_h3]:mt-5 [&_p]:my-3 [&_p]:leading-relaxed [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_li]:my-1 [&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-xs [&_strong]:text-primary"
        dangerouslySetInnerHTML={{ __html: mdToHtml(md) }}
      />
    </div>
  );
}
